var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 7.50008V5.00008C13.3335 3.15913 11.8411 1.66675 10.0001 1.66675C8.1592 1.66675 6.66681 3.15913 6.66681 5.00008V7.50008M2.99348 8.62672L2.49348 13.9601C2.35132 15.4765 2.28023 16.2347 2.53185 16.8203C2.75289 17.3348 3.14024 17.7601 3.63183 18.0282C4.19142 18.3334 4.95295 18.3334 6.47602 18.3334H13.5243C15.0473 18.3334 15.8089 18.3334 16.3685 18.0282C16.86 17.7601 17.2474 17.3348 17.4684 16.8203C17.7201 16.2347 17.649 15.4765 17.5068 13.9601L17.0068 8.62672C16.8868 7.3462 16.8267 6.70595 16.5388 6.22188C16.2851 5.79557 15.9104 5.45434 15.4623 5.24162C14.9535 5.00008 14.3104 5.00008 13.0243 5.00008L6.97602 5.00008C5.68989 5.00008 5.04682 5.00008 4.53799 5.24162C4.08987 5.45434 3.71515 5.79557 3.46153 6.22188C3.17355 6.70594 3.11353 7.3462 2.99348 8.62672Z",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shoppingCart.21ca2c9fbb5ce84a3ed2d918fbe65c7e.svg";
export { ForwardRef as ReactComponent };